module.exports = __webpack_public_path__ + "static/media/Inclusive Software Design in Maya.0d43b9e2.png";